import ControlViewModel from '@/ViewModels/ControlViewModel';
import LinkViewModel from '@/ViewModels/Controls/LinkViewModel';
import Utilities from '@/Utility/Utilities';
import { IDetailViewGroupDTO, IDVGItemDTO } from "coreframetypings/dto";
import { IGridControlFactory } from '#/DefaultViewExtensionInterfaces';
import LabelViewModelT from '@/ViewModels/Controls/LabelViewModel';
import ComponentManager from '@/Management/ComponentManager';
import AffixWrapperT from '@/Utility/AffixWrapper';
import Context from '@/ViewModels/Context';

export default abstract class ContainerViewModel extends ControlViewModel {
    private LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');
    private AffixWrapper = ComponentManager.getUtility<typeof AffixWrapperT>('AffixWrapper');

    /**
     * Der Kontext des ViewModels
     */
    public context: Context;

    /**
     * Enthält den Link
     */
    public link: LinkViewModel;

    /**
     * Enthält die inneren DetailViewItems
     */
    public detailViewItems: Array<IDVGItemDTO>;

    /**
     * Enthält die inneren DetailViewGroups
     */
    public detailViewGroups: Array<IDetailViewGroupDTO>;

    public updateLabel(): void {
        if (Utilities.isNullOrUndefined(this.link?.label))
            return;

        const caption = this.createLabelPostfix();
        this.link.label.postfix = new this.LabelViewModel({
            caption: caption,
            isVisible: this.defineComputed(() => {
                const value = caption();
                return !String.isNullOrEmpty(value);
            })
        });

        // Caption des Labels muss neu geladen werden, aufgrund des neuen Postfix-Objekts
        this.link.label.refreshCaption.valueHasMutated();
    }

    public createLabelPostfix(): KnockoutObservable<string> {
        if (this.context?.isDisposed !== false)
            return this.observableOrDefault('');

        const factories = this.context.getCreatedControlFactories();
        if (Utilities.isNullOrUndefined(factories))
            return this.observableOrDefault('');

        const alvs = factories.filter(factory => {
            // Überprüfung ob die Factory zum aktuellen Container gehört und IGridControlFactory implementiert wird
            return this.detailViewItems.indexOf(factory.detailViewItem) >= 0 && "getContainerPostfix" in factory;
        }).map(alv => {
            return {
                list: alv,
                postfix: (alv as unknown as IGridControlFactory).getContainerPostfix()
            }
        });

        return this.defineComputed(() => {
            const visibleALVs = alvs.filter(x => x.list.isVisible());

            if (visibleALVs.length != 1)
                return '';

            const postfixValue = visibleALVs[0].postfix();
            return this.AffixWrapper.wrapPostfix(postfixValue);
        });
    }
}